<template>
  <v-container fluid>
    <v-card class="flex">
      <v-card-text>
        <v-row fluid>
          <v-col cols="8">
            <v-card>
              <v-text-field v-model="searchText" hide-details label="Enter text to filter the table below"
                class="ma-2 pa-2" append-icon="mdi-magnify">
              </v-text-field>
            </v-card>
          </v-col>
          <v-col cols="4" v-if="selectedUser">
            <v-btn color="primary" class="ma-2" outlined @click="clearUserSelection">Back
              <i aria-hidden="true" class="v-icon notranslate v-icon--right mdi mdi-keyboard-backspace theme--light"
                style="font-size: 16px"></i>
            </v-btn>
          </v-col>
          <v-col cols="4" v-if="!selectedUser">
            <v-btn color="primary" class="ma-2" outlined @click="downloadExcel">Download
              <i aria-hidden="true" class="v-icon notranslate v-icon--right mdi mdi-table theme--light"
                style="font-size: 16px"></i>
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="userList && !selectedUser">
          <v-col cols="12" style="font-size: xx-small;">
            <v-data-table @click:row="userSelected" dense fixed-header sort-by="dateJoinedSerial" sort-desc
              :headers="userStatsHeaders" :items="userList" :search="searchText" item-key="userId" class="elevation-1"
              must-sort :footer-props="{ 'items-per-page-options': [25, 50, 100, -1] }">
              <template v-slot:item.lastLoginSerial="{ item }">
                <span style="white-space: nowrap">
                  {{ formatPalmDateTime(item.lastLoginSerial) }}</span>
              </template>
              <template v-slot:item.dateJoinedSerial="{ item }">
                <span style="white-space: nowrap">
                  {{ formatPalmDate(item.dateJoinedSerial) }}</span>
              </template>
              <template v-slot:item.lastActivitySerial="{ item }">
                <span style="white-space: nowrap">
                  {{ formatPalmDateTime(item.lastActivitySerial) }}</span>
              </template>
            </v-data-table>
          </v-col>
        </v-row>


        <v-row v-if="userTrendsGrid && !selectedUser">
          <v-col cols="12">
            <v-data-table :headers="userTrendsHeaders" :items="userTrendsGrid" class="elevation-1" hide-default-footer
              hide-default-header disable-pagination calculate-widths mobile-breakpoint="0" dense>
            </v-data-table>
          </v-col>
        </v-row>

        <v-row v-if="totalUserCount">
          <v-col cols="12">
            <v-card>
              <v-card-title>
                Total Users: {{ totalUserCount }}
              </v-card-title>
              <v-card-subtitle>
                <em>excludes banned users and users who have registered but not confirmed their registration details</em>
              </v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>

        <v-row v-if="selectedUser">
          <v-col cols="12">
            <user-form :user="selectedUser" />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import UserForm from "../components/UserForm";

import serverFunctions from "@/functions/serverFunctions";
import userFunctions from "@/functions/userFunctions";
import dateFunctions from "@/functions/dateFunctions";
import * as XLSX from 'xlsx';

export default {
  components: {
    "user-form": UserForm,
  },
  data: () => ({
    userList: null,
    userTrends: null,
    userTrendsGrid: null,
    searchText: null,
    selectedUser: null,
    totalUserCount: null,
    userStatsHeaders: [
      { text: 'Email', value: 'email' },
      { text: 'Forename', value: 'forename' },
      { text: 'Surname', value: 'surname' },
      { text: 'Logins', value: 'noLogins' },
      { text: 'Posts', value: 'posts' },
      { text: 'Date Joined', value: 'dateJoinedSerial' },
      { text: 'Last Login', value: 'lastLoginSerial' },
      { text: 'Last Activity', value: 'lastActivitySerial' },
      { text: 'Owner?', value: 'isOwner' },
      { text: 'Mod?', value: 'isModerator' },
      { text: 'Ban?', value: 'banned' },
    ],
    userTrendsHeaders: [
      { value: "Col0", sortable: false },
      { align: "start", value: "Col1" },
      { align: "start", value: "Col2" },
      { align: "start", value: "Col3" },
      { align: "start", value: "Col4" },
      { align: "start", value: "Col5" },
      { align: "start", value: "Col6" },
      { align: "start", value: "Col7" },
      { align: "start", value: "Col8" },
      { align: "start", value: "Col9" },
      { align: "start", value: "Col10" },
      { align: "start", value: "Col11" },
      { align: "start", value: "Col12" }
    ],

  }),
  beforeMount() {
    this.getUserStats();
  },
  methods: {
    async userSelected(user) {

      const getUserDetailsRequest = serverFunctions.getDataRequestObject(
        userFunctions.getLoggedInUser(),
        user.userId
      );

      let getResult = await serverFunctions.getPostResponse("/getSpecificUser", getUserDetailsRequest);

      this.selectedUser = getResult[0];

    },
    clearUserSelection() {
      this.selectedUser = null;
      this.getUserStats();
    },
    downloadExcel() {
      const data = XLSX.utils.json_to_sheet(this.userList)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, data, 'data')
      let filename = 'epsUserList' + dateFunctions.serialisePalmDateTime(new Date()) + '.xlsx';
      XLSX.writeFile(wb, filename)
    },
    formatPalmDateTime(datetime) {
      if (datetime && datetime.slice(0, 8) == '20000101') {
        return null
      }
      return (!datetime) ? null : dateFunctions.formatPalmDateTimeISO(datetime.slice(0, 8), datetime.slice(8, 14), false);
    },
    formatPalmDate(datetime) {
      return (!datetime) ? null : dateFunctions.formatPalmDateISO(datetime.slice(0, 8));
    },
    async getUserStats() {

      let userStatsRequest = serverFunctions.getDataRequestObject(
        userFunctions.getLoggedInUser()
      );

      this.userList = await serverFunctions.getPostResponse(
        "/userStats",
        userStatsRequest
      );

      this.userTrends = await serverFunctions.getPostResponse(
        "/getUserTrendActivity",
        userStatsRequest
      );

      this.processUserTrendsData();

      let userCountResult = await serverFunctions.getPostResponse(
        "/getUserCountSummary",
        userStatsRequest
      );

      this.totalUserCount = userCountResult[0];

    },
    processUserTrendsData() {
      this.userTrendsGrid = [];
      this.userTrendsGrid.push(this.getUserTrendData('Activity Type', 'header'))
      this.userTrendsGrid.push(this.getUserTrendData('New Users', 'joined'))
      // this.userTrendsGrid.push(this.getUserTrendData('Users Active', 'active'))
      this.userTrendsGrid.push(this.getUserTrendData('User Posts', 'posts'))
      this.userTrendsGrid.push(this.getUserTrendData('User   Messages', 'messages'))
    },
    getUserTrendData(caption, type) {
      let trendLine = {}
      Object.assign(trendLine, { "Col0": caption })
      for (let i = 11; i >= 0; i--) {
        let currentDate = new Date();
        let targetDate = this.addMonths(currentDate, -i);
        let newObj = {}
        let colName = "Col" + (12 - i).toString();
        if (type == 'header') {
          newObj[colName] = dateFunctions.getFormattedDate(targetDate, "MMM YYYY");
          Object.assign(trendLine, newObj)
        } else {
          let key = dateFunctions.getFormattedDate(targetDate, "YYYYMM");
          let trendData = this.userTrends.filter(trend => trend.type == type && trend.month == key)
          let value = (trendData.length > 0) ? trendData[0].count : 0;
          newObj[colName] = value;
          Object.assign(trendLine, newObj)
        }
      }
      return trendLine;
    },
    addMonths(date, months) {
      var d = date.getDate();
      date.setMonth(date.getMonth() + +months);
      if (date.getDate() != d) {
        date.setDate(0);
      }
      return date;
    }
  },
};
</script>

<style scoped>
.white-text {
  color: white;
}
</style>
